
export default {
    props: ['value', 'label', 'name' , 'required', 'disabled', 'placeholder', 'password', 'error', 'help', 'quantity', 'id', 'mask', 'phoneConfirm', 'big'],
    data() {
        return {
            isFocused: false,
        };
    },
    computed:{
        type(){
            if(this.password){
                return 'password';
            }
            if(this.quantity){
                return 'number';
            }
            return 'text';
        },
        maskSettings(){
            if(this.mask){
                return {
                    mask: this.mask,
                    showMaskOnHover: false,
                }
            }else{
                return null;
            }
        },
    },
    methods: {
        plus(){
            if (!this.disabled) this.$emit('input', Number(this.value || 0) + 1);
        },
        minus(){
            if(!this.disabled && Number(this.value) > 1){
                this.$emit('input', Number(this.value) - 1);
            }
        },
    },
}
